import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Button } from "@/DesignSystem/Molecules/Button";

import styles from "./AIScribe.module.scss";

/**
 * Interface for the properties used in the AI Scribe Warning Active Assistant.
 *
 * @interface IAIScribeWarningActiveAssistantProps
 * @property {Function} onOk - Callback function to be called when the user confirms or acknowledges the warning.
 * @property {Function} onClose - Callback function to be called when the warning is closed or dismissed.
 */
interface IAIScribeWarningActiveAssistantProps {
    /**
     * Callback function to handle the "Ok" action.
     *
     * @returns {void}
     */
    onOk: () => void;

    /**
     * Callback function to handle the "Close" action.
     *
     * @returns {void}
     */
    onClose: () => void;
}

function AIScribeWarningActiveAssistant(props: Readonly<IAIScribeWarningActiveAssistantProps>): JSX.Element {
    const { getText } = useTranslation();

    function handleCheckStatusClicked(): void {
        props.onOk();
    }

    function renderFooter(): JSX.Element {
        return (
            <div className="flex-container flex-end">
                <ButtonGroup>
                    <Button
                        category="primary"
                        variant="brand"
                        label={getText("Ok_Label")}
                        onClick={handleCheckStatusClicked}
                        id="ai-scribe-ai-assistant-ok"
                        dataCy="ai-scribe-ai-assistant-ok"
                    />
                </ButtonGroup>
            </div>
        );
    }

    return (
        <Modal
            fixedOverlayPosition
            showX
            showOverlay
            disableOverlayClose
            draggable
            roundTopCorner
            width={465}
            title={getText("AIScribe_WarningAIAssistant_Title")}
            id="ai-scribe-warning-ai-assistant-popup"
            dataCy="ai-scribe-warning-ai-assistant-popup"
            footer={renderFooter()}
            cssClass={styles.subscriptionExpiredPopup}
            onClose={props.onClose}
        >
            <div className={styles.body}>
                <p className={styles.firstSentence}>{getText("AIScribe_WarningAIAssistant_Message1")}</p>
                <p className={styles.secondSentence}>{getText("AIScribe_WarningAIAssistant_Message2")}</p>
            </div>
        </Modal>
    );
}

export { AIScribeWarningActiveAssistant };
